import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "./Reveal";

const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

const ServiceCard = ({ s, i }) => (
  <article data-testid={`service-card-${i + 1}`} className="group relative flex h-full min-h-[460px] flex-col justify-between overflow-hidden border border-white/10 bg-ink-2 p-7 sm:p-10">
    {s.img ? (
      <>
        <img src={s.img} alt={s.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-55 grayscale transition-[transform,filter,opacity] duration-[1200ms] group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0" />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink via-ink/85 to-ink/20" />
      </>
    ) : (
      <span aria-hidden className="stroke-text pointer-events-none absolute -bottom-12 -right-4 select-none font-display text-[12rem] font-semibold leading-none transition-transform duration-700 group-hover:-translate-y-2">0{i + 1}</span>
    )}
    <div className="relative flex items-start justify-between">
      <span className="font-mono text-xs tracking-[0.2em] text-signal">0{i + 1} / 04</span>
      <span className="grid h-10 w-10 place-items-center rounded-full border border-white/15 transition-[background-color,transform] duration-500 group-hover:rotate-45 group-hover:bg-signal group-hover:text-ink"><ArrowUpRight className="h-4 w-4" /></span>
    </div>
    <div className="relative mt-16">
      <h3 className="max-w-md font-display text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">{s.title}</h3>
      <p className="mt-4 max-w-lg text-zinc-300">{s.desc}</p>
      <ul className="mt-6 space-y-2.5">
        {s.points.map((p) => (
          <li key={p} className="flex gap-3 text-sm text-zinc-300"><span className="mt-[0.45rem] h-1.5 w-1.5 shrink-0 bg-signal" />{p}</li>
        ))}
      </ul>
    </div>
    <span aria-hidden className="absolute inset-x-0 bottom-0 h-px origin-left scale-x-0 bg-signal transition-transform duration-700 group-hover:scale-x-100" />
  </article>
);

export const Services = () => {
  const { t } = useI18n();
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-40">
      <div className="wrap">
        <SectionHead label={t.services.label} title={t.services.title} intro={t.services.intro} />
        <div className="mt-16 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-5">
          {t.services.items.map((s, i) => (
            <Reveal key={s.title} delay={(i % 2) * 0.08} className={SPANS[i]}>
              <ServiceCard s={s} i={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
